import { render, staticRenderFns } from "./VideoCard.vue?vue&type=template&id=77db1acc&"
import script from "./VideoCard.vue?vue&type=script&lang=ts&"
export * from "./VideoCard.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports